module.exports = __webpack_public_path__ + "static/Sang-Tere1-6d9647c7146343e7afcb0c6011538156.png";